import { FormStepId } from 'shared/config/formStepId';
import type { LottieOptions } from 'shared/ui/lottie.loader';

import accuracy1Data from './assets/accuracy1.json';
import accuracy2Data from './assets/accuracy2.json';
import accuracy3Data from './assets/accuracy3.json';
import accuracy4Data from './assets/accuracy4.json';

type TCreditCardFormProgressConfigItem = {
  accuracy: string;
  percent: number;
  stepLabel: string;
  animationData?: LottieOptions['animationData'];
};

export const CREDIT_CARD_FORM_PROGRESS_CONFIG: Record<FormStepId, TCreditCardFormProgressConfigItem> = {
  [FormStepId.CreditPurposeInfo]: {
    accuracy: 'Низкая',
    percent: 10,
    stepLabel: 'первый',
    animationData: accuracy1Data,
  },
  [FormStepId.ContactsInfo]: {
    accuracy: 'Низкая',
    percent: 20,
    stepLabel: 'второй',
    animationData: accuracy1Data,
  },
  [FormStepId.PassportInfo]: {
    accuracy: 'Средняя',
    percent: 60,
    stepLabel: 'третий',
    animationData: accuracy2Data,
  },
  [FormStepId.WorkplaceInfo]: {
    accuracy: 'Высокая',
    percent: 80,
    stepLabel: 'четвертый',
    animationData: accuracy3Data,
  },
  [FormStepId.AdditionalInfo]: {
    accuracy: 'Максимальная',
    percent: 100,
    stepLabel: 'пятый',
    animationData: accuracy4Data,
  },
};
